import { candidateOverviewConstants } from './creator';

export const candidateOverviewModuleInitialState = {
  data: {},
  loading: false,
};

const MAPPED_REDUCERS = {
  [candidateOverviewConstants.SET_CANDIDATE_DATA]: (state, { payload }) => ({
    ...state,
    data: payload,
    loading: false,
  }),
};

// eslint-disable-next-line default-param-last
function candidateOverviewReducer(state = candidateOverviewModuleInitialState, action) {
  const handler = MAPPED_REDUCERS[action.type];

  return handler ? handler(state, action) : state;
}

export default candidateOverviewReducer;
